/**
 * Reservation Constants for CarBooking Module
 * Constantes y configuración para el módulo de reservas
 */

/**
 * Diccionario de estados de reserva
 * @constant
 */
export const ESTADO_INFO = {
    1: { key: "PENDING", label: "Pendiente de autorización", cls: "warn" },
    2: { key: "CONFIRMED", label: "Confirmada (sin flujo)", cls: "ok" },
    3: { key: "AUTHORIZED", label: "Autorizada", cls: "ok" },
    4: { key: "REJECTED", label: "Rechazada", cls: "danger" },
    5: { key: "CANCELLED", label: "Cancelada", cls: "danger" },
    6: { key: "COMPLETED", label: "Completada", cls: "ok" },
};

/**
 * Tipos de aprobación según catálogo
 * @constant
 */
export const TIPO_APROBACION = {
    FUERA_HORARIO: 1, // IdTipoAprobacion = 1
    HORAS_SEMANA_EXCEDIDAS: 2, // 2
    HORAS_MES_EXCEDIDAS: 4, // 4
    FIN_SEMANA: 5, // 5
    DIAS_FESTIVOS: 7, // 7
    VARIOS_DIAS: 8, // 8 - Reservas de varios días
    GENERAL: 9, // 9 - Puede aprobar cualquier tipo de reserva
};

/**
 * Obtiene la información de un estado de reserva
 * @param {number} id - ID del estado
 * @returns {Object} Información del estado {key, label, cls}
 */
export function getEstadoInfo(id) {
    return ESTADO_INFO[id] || ESTADO_INFO[1];
}

/**
 * Obtiene el color CSS para un chofer basado en su ID
 * @param {number} _id - ID del chofer
 * @returns {string} Variable CSS del color
 */
export function getDriverColorFromId(_id) {
    return "var(--gradient-driver-main)";
}
